import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isObservable, Observable, of } from 'rxjs';

@Component({
  selector: 'ps-ui-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent {
  @Input() selected: boolean = false;
  @Input() disabled: boolean = false;
  @Input() beforeToggleChange: beforeToggleChangeCallback = () => true;
  @Output() selectedChange = new EventEmitter<boolean>();

  constructor() {}

  onChange(event: any) {
    let canChangeToggle = this.beforeToggleChange();
    if (!isObservable(canChangeToggle)) {
      canChangeToggle = of(canChangeToggle);
    }
    canChangeToggle.subscribe((canChange) => {
      if (!canChange) {
        event.target.checked = !event.target.checked;
      }
      this.selectedChange.emit(event.target.checked);
    });
  }
}

type beforeToggleChangeCallback = () => boolean | Observable<boolean>;
